import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { closeDialog, displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { SupportCaseReportTopBannerProps } from "models/propTypes/supportPropTypes";
import { FAQConstants } from "utils/constants";
//#endregion
//#region components
import { BannerWithCommentBox } from "components/common";
import useSupportTicketCreateDialog from "./useCreateDialog";
import useSupportTicketCreateDialogWithFAQ from "./useCreateDialogWithFAQ";
import useOldSupporDialogHelper from "./useOldSupporDialogHelper";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SupportCaseReportTopBanner: React.FC<SupportCaseReportTopBannerProps> = (props) => {
  const { data, loading } = props.supportTeamData || { data: null, loading: false };
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { hasOldSupportDialog } = useOldSupporDialogHelper();
  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();
  const supportTicketDialog = getSupportTicketCreateDialog(props.reloadSupportCases);
  const supportTicketDialogWithFAQ = useSupportTicketCreateDialogWithFAQ(undefined, () => dispatch(closeDialog()));

  // Hide when loading or when the SupportTeamBanner is showing (team data available)
  if (loading || (data?.team && data.team.members.length > 0)) return null;

  const onSupportCreationClicked = async () => {
    if (hasOldSupportDialog) {
      dispatch(displayDialog(supportTicketDialog));
    } else {
      dispatch(displayDialog(supportTicketDialogWithFAQ));
    }
  };

  return (
    <BannerWithCommentBox
      commentBoxTitle={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.SupportIssue.DashboardHeaderTitle
      )}
      commentBoxDescription={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.SupportIssue.DashboardHeaderDescription
      )}
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQSupportFlowAskAQuestion),
          onClick: onSupportCreationClicked,
        },
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FaqText),
          onClick: () => {
            window.open(FAQConstants.FAQUrl, "_blank");
          },
        },
      ]}
    ></BannerWithCommentBox>
  );
};

export default SupportCaseReportTopBanner;
